import * as ActionTypes from "constants/ActionTypes";

const initialState = {
    models: [],
    isLoading: false,
    serviceError: "",
    serviceCode: 200,
    reqStatus: "",
};

export default function(state: Object = initialState, action: Object) {
    switch (action.type) {
        // Get models
        case ActionTypes.ADMIN_GET_SYSTEM_MODELS_START:
        case ActionTypes.ADMIN_CREATE_SYSTEM_MODEL_START:
        case ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_START:
        case ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_IMAGE_START:
        case ActionTypes.ADMIN_DELETE_SYSTEM_MODEL_START:
        case ActionTypes.ADMIN_TOGGLE_SYSTEM_MODEL_ACTIVE_START:
            return {
                ...state,
                isLoading: true,
                reqStatus: action.type,
                serviceError: "",
            };

        case ActionTypes.ADMIN_GET_SYSTEM_MODELS_FAILURE:
        case ActionTypes.ADMIN_CREATE_SYSTEM_MODEL_FAILURE:
        case ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_FAILURE:
        case ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_IMAGE_FAILURE:
        case ActionTypes.ADMIN_DELETE_SYSTEM_MODEL_FAILURE:
        case ActionTypes.ADMIN_TOGGLE_SYSTEM_MODEL_ACTIVE_FAILURE:

            return {
                ...state,
                isLoading: false,
                reqStatus: action.type,
                serviceError: { ...action.payload },
            };


        case ActionTypes.ADMIN_GET_SYSTEM_MODELS_SUCCESS:
            if (action.payload.statusCode === 200) {
                return {
                    ...state,
                    reqStatus: action.type,
                    serviceError: "",
                    serviceCode: action.payload.statusCode,
                    isLoading: false,
                    models: action.payload.response
                };
            } else {
                return {
                    ...state,
                    reqStatus: action.type,
                    serviceError: "",
                    serviceCode: action.payload.statusCode,
                    isLoading: false,
                    models: []
                };

            }


        case ActionTypes.ADMIN_CREATE_SYSTEM_MODEL_SUCCESS:
            return {
                ...state,
                models: [...state.models, action.model],
                isLoading: false,
                error: null
            };

        case ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_SUCCESS:
            return {
                ...state,
                models: state.models.map(model =>
                    model._id === action.model._id ? action.model : model
                ),
                isLoading: false,
                error: null
            };


        case ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_IMAGE_SUCCESS:
            return {
                ...state,
                models: state.models.map(model =>
                    model._id === action.model._id ? action.model : model
                ),
                isLoading: false,
                error: null
            };

        case ActionTypes.ADMIN_DELETE_SYSTEM_MODEL_SUCCESS:
            return {
                ...state,
                models: state.models.filter(model => model._id !== action.modelId),
                isLoading: false,
                error: null
            };

        case ActionTypes.ADMIN_TOGGLE_SYSTEM_MODEL_ACTIVE_SUCCESS:
            return {
                ...state,
                models: state.models.map(model =>
                    model._id === action.modelId
                        ? { ...model, is_active: action.isActive }
                        : model
                ),
                isLoading: false,
                error: null
            };

        default:
            return state;
    }
};
